import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index.js'

// Import CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

// Import JS
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Crea l'app Vue
const app = createApp(App)

// Configura Pinia (store)
const pinia = createPinia()
app.use(pinia)

// Configura Router
app.use(router)

// Monta l'app
app.mount('#app')

console.log('🚀 Vue App inizializzata con Router e Store!')